import React, {useState, useEffect, useCallback} from 'react';
import {useParams} from 'react-router-dom';
import {getGuardianById} from '../../../api/guardian/guardianApiClient';
import GuardianDetail from './GuardianDetail';
import SoftBox from '../../../components/SoftBox';
import SoftTypography from '../../../components/SoftTypography';
import SoftAlert from '../../../components/Alert';

function GuardianDetailWrapper() {
    const [guardian, setGuardian] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showAlert, setShowAlert] = useState(false);
    const {guardianId} = useParams();

    const loadGuardianDetails = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);

            console.log('Loading guardian details for ID:', guardianId);

            if (!guardianId) {
                throw new Error('Guardian ID is required');
            }

            // Load guardian details
            const guardianResponse = await getGuardianById(guardianId);
            console.log('Guardian response:', guardianResponse);
            setGuardian(guardianResponse.data);

        } catch (error) {
            console.error('Error loading guardian details:', error);
            console.error('Error details:', {
                message: error.message,
                response: error.response,
                status: error.response?.status,
                data: error.response?.data
            });
            setError(`Failed to load guardian details: ${error.message}`);
            setShowAlert(true);
        } finally {
            setLoading(false);
        }
    }, [guardianId]);

    useEffect(() => {
        if (guardianId) {
            loadGuardianDetails();
        }
    }, [guardianId, loadGuardianDetails]);

    if (loading) {
        return (
            <SoftBox p={2} display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                <SoftTypography>Loading guardian details...</SoftTypography>
            </SoftBox>
        );
    }

    if (!guardian) {
        return (
            <SoftBox p={2}>
                <SoftTypography variant="h6" color="error">
                    Guardian not found
                </SoftTypography>
                <SoftTypography variant="body2" color="text.secondary">
                    The requested guardian may not exist or has been removed.
                </SoftTypography>
            </SoftBox>
        );
    }

    return (
        <SoftBox>
            <GuardianDetail guardian={guardian}/>

            {error && (
                <SoftAlert
                    color="error"
                    dismissible={false}
                    timeout={10}
                    mount={showAlert}
                    onClose={() => {
                        setError(null);
                        setShowAlert(false);
                    }}
                >
                    {error}
                </SoftAlert>
            )}
        </SoftBox>
    );
}

export default GuardianDetailWrapper;
